import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import Translation from '../../../containers/i18n/Translation';
import { SUPPORT } from '../../../routes/paths';
import Button from '../../common/Button';

export const CashInFailure = ({ close, history }) => {
  const goToSupport = () => {
    close();
    history.push(SUPPORT);
  };

  return (
    <div className="modal">
      <h2 className="modal__header">
        <Translation section="cashInFailure" label="title" />
      </h2>
      <p className="modal__paragraph">
        <Translation section="cashInFailure" label="question" />
      </p>
      <p className="modal__paragraph">
        <Translation section="cashInFailure" label="moreInfoPrefix" />
        <span onClick={goToSupport} className="modal__link">
          <Translation section="cashInFailure" label="moreInfoLink" />
        </span>
        <Translation section="cashInFailure" label="moreInfoSuffix" />
      </p>
      <Button className="modal__button" onClick={close}>
        <Translation section="common" label="ok" />
      </Button>
    </div>
  );
};

CashInFailure.propTypes = {
  close: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default withRouter(CashInFailure);
